module.exports = __webpack_public_path__ + "334f89f61e7b2553dfc2f1fbbbae9864.pdf";